import ComparisonWorkspace from "../components/personal/main_page/ComparisonWorkspace";
import MainNavbar from "../components/reuse/navbar";

export default function ComparisonMaps() {
  return (
    <>
      <div>
        <MainNavbar />
      </div>
      <ComparisonWorkspace />
    </>
  );
}
